import { createAction } from '@reduxjs/toolkit';

export const analyzeContentForm = createAction<{
  formId: string,
  formName: string,
}>('analyzeContentForm');
